import { Component, OnInit } from "@angular/core";
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { ZpDataService } from "./../../services/zp-data.service";
import { UserInfoService } from "./../../services/user-info.service";
import { SideNavBarVisibilityService } from "./../../services/side-nav-bar-visibility.service";
import { UserIdleService } from "angular-user-idle";
import { ThemeService } from "src/app/theme/theme-service.service";

@Component({
    selector: "app-login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss"],
    standalone: false
})
export class LoginComponent implements OnInit {
  public loginForm: UntypedFormGroup;
  public mfaForm: UntypedFormGroup;
  public loader = false;
  public submitted = false;
  public returnUrl: string;
  public error = "";
  public authenticationService: any;
  public alertService: any;
  public id: any;
  public loginFail: boolean = false;
  public MFAFail: boolean = false;
  public hasSharedPlans = false;
  public hasPlan: any;
  public mySharedPlans: {}[];
  public isProfessional: boolean;
  public doMFA = false;
  public MFAEmpty: boolean = false;
  public statusPassword: any;
  public capsOn: any;
  public myUser: any;
  public disabled: boolean;
  public currentURL: string;
  public activeTheme: any;
  public isDefaultTheme: boolean;
  public isEmail: boolean = false;
  public isMobile: boolean = false;
  disableSignIn: boolean;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private ZpDataService: ZpDataService,
    private userInfo: UserInfoService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private userIdle: UserIdleService,
    public themeService: ThemeService
  ) {
    this.currentURL = window.location.href;
  }

  ngOnInit() {
    this.sideNavBarVisibilityService.hideSideNav = true;
    this.loginForm = this.formBuilder.group({
      userName: ["", [Validators.required, Validators.email]],
      password: ["", Validators.required],
    });
    this.mfaForm = this.formBuilder.group({
      mfaCode: ["", [Validators.required]],
    });
    this.userInfo.changeMessage("");
    this.activeTheme = this.themeService.active;
    if (this.activeTheme.theme != "default") {
      this.isDefaultTheme = false;
      console.log("isDefaultTheme: ", this.isDefaultTheme);
    }
  }

  get f() {
    return this.loginForm.controls;
  }

  get mf() {
    return this.mfaForm.controls;
  }

  // async completeLogin() {
  //   this.loader = true;
  //   if (this.id) {
  //     this.myUser = await this.ZpDataService.getItemUser(this.id, "users");
  //     console.log("myUser: ", this.myUser);
  //     let subscriptionStatus = await this.ZpDataService.getSubscriptionStatus();
  //     if (
  //       this.ZpDataService.subscriptionNotValid ||
  //       subscriptionStatus === "Payment Required" ||
  //       (subscriptionStatus && !subscriptionStatus["active"])
  //     ) {
  //       if (
  //         this.myUser.subscriptionId ||
  //         (subscriptionStatus.method &&
  //           subscriptionStatus.method.customerId &&
  //           !subscriptionStatus.active)
  //       ) {
  //         this.router.navigate(["/payment-subscription"]);
  //       } else if (this.myUser.userType == "professional") {
  //         this.router.navigate(["/payment-choose-licenses"]);
  //         this.sideNavBarVisibilityService.changeMessage("none");
  //         this.isProfessional = true;
  //         return;
  //       } else if (
  //         this.myUser.userType == "planHolder" ||
  //         this.myUser.userType == undefined
  //       ) {
  //         this.router.navigate(["/payment-choose-plan"]);
  //         this.isProfessional = false;
  //         return;
  //       } // Ignore admins. re: payment.
  //     }
  //   }

  //   if (this.myUser) {
  //     console.log("myUser: ", this.myUser);
  //     this.isEmail = this.myUser.mfaVia === "Email" ? true : false;
  //     this.isMobile =
  //       this.myUser.mfaVia === "Email"
  //         ? false
  //         : this.myUser.mfaVia === "SMS"
  //         ? true
  //         : false;
  //     this.userInfo.changeMessage(JSON.stringify(this.myUser));
  //     this.mySharedPlans = await this.ZpDataService.getMySharedPlans(
  //       this.myUser["Id"]
  //     );
  //     this.hasPlan = await this.ZpDataService.getPlan(this.myUser["Id"]);
  //     let urlParams = this.ZpDataService.redirectParams();
  //     let url = this.ZpDataService.redirectUrl();
  //     if (url) {
  //       this.router.navigate([url, urlParams]);
  //     } else {
  //       if (this.myUser) {
  //         this.checkMfaAlways();
  //       }
  //       if (
  //         // Special case when plan holder is also a delegate
  //         !this.hasPlan &&
  //         this.mySharedPlans &&
  //         this.mySharedPlans.length > 0 &&
  //         this.myUser.userType == "planHolder"
  //       ) {
  //         this.sideNavBarVisibilityService.changeMessage("none");
  //         this.checkMfaAlways();
  //       }
  //     }
  //     if (
  //       // case if the user if a pure delegate
  //       this.mySharedPlans &&
  //       this.mySharedPlans.length > 0 &&
  //       !this.hasPlan &&
  //       this.myUser.userType == undefined
  //     ) {
  //       console.log("userType", this.myUser.userType);
  //       this.sideNavBarVisibilityService.changeMessage("top");
  //       this.router.navigate(["/delegate-home-page"]);
  //     } else {
  //       this.sideNavBarVisibilityService.changeMessage("bottom");
  //     }
  //   } else {
  //     this.loginFail = true;
  //   }
  // }

  async checkMfaAlways() {
    if (!this.myUser) {
      this.myUser = await this.ZpDataService.getItemUser(this.id, "users");
    }
    switch (this.myUser.mfaAlways) {
      case undefined:
        await this.ZpDataService.requestMFACode();
        this.doMFA = true;
        break;
      case "Yes":
        await this.ZpDataService.requestMFACode();
        this.doMFA = true;
        break;
      case "No":
        this.sendToLocation(this.myUser);
        break;
    }
  }

  async onSubmit() {
    this.submitted = true;
    this.disabled = true;
    setTimeout(() => {
      this.disabled = false;
    }, 3000);
    if (this.loginForm.invalid) {
      return;
    }
    this.userIdle.startWatching();
    let loginResponse = await this.ZpDataService.checkPassword(
      "users",
      this.loginForm.controls["userName"].value.toLowerCase(),
      this.loginForm.controls["password"].value
    );
    this.id = loginResponse.id;
    console.log("this.id", this.id);
    if (!this.id) {
      return;
    }
    // if (localStorage.mstesmarker) {
    //   let mstesmarker = JSON.parse(localStorage.mstesmarker);
    //   let code =
    //     mstesmarker[this.loginForm.controls["userName"].value.toLowerCase()];
    //   if (code) {
    //     let result = await this.ZpDataService.confirmMFACode(code);
    //     if (result.success) {
    //       // let a = await this.completeLogin();
    //       this.checkMfaAlways();
    //     } else {
    //       delete mstesmarker[
    //         this.loginForm.controls["userName"].value.toLowerCase()
    //       ];
    //       localStorage.mstesmarker = JSON.stringify(mstesmarker);
    //       await this.ZpDataService.requestMFACode();
    //       this.doMFA = true;
    //     }
    //   }

    //   else {
    //     if (!this.doMFA) {
    //       await this.ZpDataService.requestMFACode();
    //       this.doMFA = true;
    //       this.isMobile = loginResponse.mfaVia === "SMS";
    //       this.isEmail = loginResponse.mfaVia === "Email";
    //     }
    //   }
    // }

    // else {
    if (!this.doMFA) {
      await this.ZpDataService.requestMFACode();
      this.doMFA = true;
      this.isMobile = loginResponse.mfaVia === "SMS";
      this.isEmail = loginResponse.mfaVia === "Email";
    }
    // }
    this.submitted = false;
  }

  async sendToLocation(myUser) {
    if (!this.myUser) {
      this.myUser = await this.ZpDataService.getItemUser(this.id, "users");
    }
    switch (this.myUser.userType) {
      // admin
      case "admin":
        this.router.navigate(["/admin-dashboard"]);
        this.sideNavBarVisibilityService.changeMessage("none");
        break;
      case "professional":
        this.router.navigate(["/professional-home-page"]);
        this.sideNavBarVisibilityService.changeMessage("none");
        this.isProfessional = true;
        break;
      // professional manager
      case "professionalManager":
        this.router.navigate(["/professional-manager-home-page"]);
        this.sideNavBarVisibilityService.changeMessage("none");
        this.isProfessional = true;
        break;
      // plan holder
      case "planHolder":
        this.router.navigate(["/home"]);
        break;
      case "invited":
        this.router.navigate(["/home"]);
        break;
      // default:
      //   // Delegate doesn't have userType
      //   this.router.navigate(["/security-page"]);
      //   console.log("myUser", this.myUser);
      //   this.sideNavBarVisibilityService.changeMessage("none");
    } 
    if (this.myUser && !this.myUser.userType) {
        // Delegate doesn't have userType
        this.router.navigate(["/delegate-home-page"]);
        console.log("myUser", this.myUser);
        this.sideNavBarVisibilityService.changeMessage("none");
    }
  }

  disableSignInBtn(ev) {
    this.doMFA = false;
    alert(
      "This account has been temporarily disabled for your security due to too many failed login attempts. Please try back later or contact support in the event that you suspect someone else has been trying to access your account."
    );
    this.disableSignIn = true;
    setTimeout(() => {
      this.disableSignIn = false;
    }, 1800000);
  }

  ngOnDestroy() {
    this.sideNavBarVisibilityService.hideSideNav = false;
  }
}
